import { useEffect, useState } from 'react'
import { defineQuery } from 'groq'
import { getClient, urlFor } from '../client'
import { useLang } from '../i18n/LocaleProvider'
import { useLiveVersion } from './useLiveVersion'
import type { NEWS_ARTICLE_QUERY_RESULT } from '../sanity.types'

type NewsArticleResult = NonNullable<NEWS_ARTICLE_QUERY_RESULT>

export type NewsArticle = Omit<NewsArticleResult, 'translation'>

const NEWS_ARTICLE_QUERY = defineQuery(`*[_type == "newsArticle" && slug.current == $slug][0] {
  ...,
  "translation": *[_type == "translation.metadata" && references(^._id)][0].translations[_key == $lang][0].value-> {
    ...
  }
}`)

export function useNewsArticle(slug: string | undefined) {
  const [article, setArticle] = useState<NewsArticle | null>(null)
  const lang = useLang()

  const live = useLiveVersion()

  useEffect(() => {
    if (!slug) return
    let active = true
    getClient()
      .fetch(NEWS_ARTICLE_QUERY, { slug, lang })
      .then((result) => {
        if (!result) return null
        const { translation, ...document } = result
        return translation?._type === 'newsArticle' ? translation : document
      })
      .then((result) => active && setArticle(result))

    return () => {
      active = false
    }
  }, [slug, lang, live])

  const articleImageUrl = article?.image ? (urlFor(article.image)?.width(550).height(310).url() ?? null) : null

  return { article, articleImageUrl }
}
